import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-patient-layout',
  templateUrl: './patient-layout.component.html',
  styleUrls: ['./patient-layout.component.scss']
})
export class PatientLayoutComponent implements OnInit {
  expandNav = false;
  className: string = '';
  constructor(private router: Router) { }

  ngOnInit() {
    this.setClassName(this.router.url);
    this.router.events.subscribe(async (ev) => {
      if (ev instanceof NavigationEnd) {
        this.setClassName(ev.url);
      }
    });
  }

  setClassName(url: string) {
    if (url.includes('patient/marketplace')) {
      this.className = 'mat-sidenav-content patient-info--wrapper padding-0';
    }
    else {
      this.className = 'mat-sidenav-content patient-info--wrapper';
    }
  }

  expandSidebar(event) {
    if (event.type === 'mouseover') {
      this.expandNav = true;
    } else {
      this.expandNav = false;
    }
  }

}
